module.exports = __webpack_public_path__ + "static/about-d61f196f7d8b22cef864c5af2ec15c96.jpg";